<template>
  <v-row>
    <v-col
      :lg="4"
      :md="6"
      :sm="12"
      cols="12"
    >
      <v-lazy
        :options="{threshold: .5}"
        transition="fade-transition"
      >
        <al-mix />
      </v-lazy>
    </v-col>

    <v-col
      :lg="8"
      :md="6"
      :sm="12"
      cols="12"
    >
      <v-lazy
        :options="{threshold: .5}"
        transition="fade-transition"
      >
        <liquidity />
      </v-lazy>
    </v-col>

    <v-col
      cols="12"
      sm="12"
    >
      <v-lazy
        :options="{threshold: .5}"
        transition="fade-transition"
      >
        <profitability />
      </v-lazy>
    </v-col>

    <v-col
      cols="12"
    >
      <v-lazy
        :options="{threshold: .5}"
        transition="fade-transition"
      >
        <gap-analysis />
      </v-lazy>
    </v-col>
  </v-row>
</template>

<script>
import AlMix from '@/theme/default/views/banking/alm/summary/blocks/AlMix.vue'
import GapAnalysis from '@/theme/default/views/banking/alm/summary/blocks/GapAnalysis.vue'
import Liquidity from '@/theme/default/views/banking/alm/summary/blocks/Liquidity.vue'
import Profitability from '@/theme/default/views/banking/alm/summary/blocks/Profitability.vue'
import API from '@/api/Api'
import { clone } from '@/lib/utils/helper'
import ALMSummaryResource from '@/api/resources/alm/ALMSummaryResource'

export default {
  name      : 'AlmSummary',
  components: {
    AlMix,
    GapAnalysis,
    Liquidity,
    Profitability
  },
  props: {
    breakpoint: {
      type   : Number,
      default: 6
    },
    selectedDate: {
      type   : String,
      default: ''
    }
  },
  dataStore: {
    ALMSummary: 'ALM.ALMSummary.Data'
  },
  computed: {
    accountId () {
      return this.user?.selectedAccountId || null
    }
  },
  watch: {
    selectedDate: {
      handler (newDate) {
        if (newDate && newDate.trim() !== '') {
          this.getData()
        }
      },
      immediate: true
    }
  },
  created () {
    if (this.selectedDate && this.selectedDate.trim() !== '') {
      this.getData()
    }
  },
  methods: {
    getData () {
      const params = this.selectedDate ? [this.accountId, this.selectedDate] : [this.accountId]
      API.Resource.ALM.GetALMSummary(...params)
        .then(response => {
          this.handleResponse(response)
        })
        .catch(e => {
          this.handleResponse(e.response)
        })
        .finally(() => {})
    },
    handleResponse (response) {
      const data = API.responseData(response)?.findALMInfo || null
      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        const o = clone(data)
        this.ALMSummary = new ALMSummaryResource(o)
      } else {
        this.ALMSummary = null
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
</script>

<style scoped>

</style>
